import { registerQuery } from 'data-fetching-client';
import { fetchAssetById, fetchAssetsByIds } from 'personalization-lib/api/clients/assetApiClient';
const getAssetMap = assets => Object.fromEntries(assets.map(asset => [asset.id, asset]));
export const ASSETS_BY_IDS_QUERY = registerQuery({
  fieldName: 'assetsById',
  args: ['source', 'ids'],
  fetcher: args => fetchAssetsByIds(args).then(getAssetMap)
});
export const ASSET_BY_ID_QUERY = registerQuery({
  fieldName: 'assetById',
  args: ['source', 'id'],
  fetcher: args => fetchAssetById(args)
});